import React from 'react';
import { useSpring, animated, interpolate } from 'react-spring';
import Links from '../../Constants/Links';
import { Link } from 'gatsby';
import styles from '../NavigationBar/nav.module.css';
import Search from '../search/index';
import { TiDeleteOutline } from 'react-icons/ti';
import scrollTo from 'gatsby-plugin-smoothscroll';
import { v4 as uuidv4 } from 'uuid';

const Nav = ({ toggle, toggleHandler }) => {
	const { o } = useSpring({ o: toggle ? 0 : 100 });
	const searchIndices = [ { name: `Pages`, title: `Pages` } ];

	return (
		<animated.div
			className={styles.navWrapper}
			style={{
				transform: o.interpolate((o) => `translate3d(${o}%,0,0)`)
			}}
		>
			<nav className={styles.nav}>
				<ul>
					<li className={styles.li}>
						<Search indices={searchIndices} />
					</li>
					{Links.map((link) => (
						<li className={styles.li} onClick={() => toggleHandler(toggle)} key={uuidv4()}>
							<Link to={link.path} className={styles.link}>
								{link.text}
							</Link>
						</li>
					))}
					<li className={styles.li} onClick={() => toggleHandler(toggle)}>
						<button className={styles.contact} onClick={() => scrollTo('#footer')}>
							CONTACT
						</button>
					</li>
				</ul>
				<TiDeleteOutline onClick={() => toggleHandler(toggle)} className={styles.close} />
			</nav>
		</animated.div>
	);
};

export default Nav;
